import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, take, switchMap, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Subject, Observable, from } from "rxjs";
import { LanguageService } from "./language.service";
import { AuthService } from "@api/Auth/auth.service";
import { HelperService } from "./helper.service";

@Injectable({
  providedIn: "root",
})
export class EventService {
  private sbj = new Subject<any>();
  private sbjAddress = new Subject<any>();
  language:any;

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    // private offlineManager: OfflineManagerService,
    private helper: HelperService,
    private languageService: LanguageService
  ) {
    this.language = this.languageService.language();
  }

  getEventList(page: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/${this.language}/event/event_list?page=${page}`
    );
  }

  getCategoryList() {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjQ5Mjd9.NGM3NmMxMDJkZjQ0MTllNjcwNjYwYmZmZTUyYzIzMTY1YTkxNjBjODJlZGRiMWVmM2Y4ZjA1YjQ3MDFhZjVhZA`,
      }),
    };
    return this.http.get<any>(
      `${environment.apiUrl}/api/category/category_list`
    );
  }

  getEventCategory(
    categoryId: number,
    page: number,
    date_start: string = "",
    date_end: string = "",
    sortby: string = "new",
    kabupaten_id: string = ""
  ) {
    return this.http.get<any>(
      // `${environment.apiUrl}/api/${this.language}/event/event_list/${categoryId}?page=${page}`
      `${environment.apiUrl}/api/${
        this.language
      }/event/event_list/${categoryId}?page=${page}&date_start=${date_start.substring(
        0,
        10
      )}&date_end=${date_end.substring(
        0,
        10
      )}&sortby=${sortby}&kabupaten_id=${kabupaten_id}`
    );
  }

  pubFilter(data: any) {
    this.sbj.next(data);
  }
  obvFilter(): Subject<any> {
    return this.sbj;
  }

  pubScanner(data: any) {
    this.sbj.next(data);
  }
  obvScanner(): Subject<any> {
    return this.sbj;
  }

  pubHeader(data: any) {
    this.sbj.next(data);
  }
  obvHeader(): Subject<any> {
    return this.sbj;
  }

  pubAddress(data: any) {
    this.sbjAddress.next(data);
  }
  obvAddress(): Subject<any> {
    return this.sbjAddress;
  }

  getSearchEvent(search: string, category_id: any = 0, page: any = 1) {
    let body = new FormData();
    body.append("page", page);
    body.append("search", search);
    body.append("language", this.language);
    if (category_id != 0) {
      body.append("category_id", category_id);
    }
    return this.http.post<any>(
      `${environment.apiUrl}/api/event/search_event`,
      body
    );
  }

  getEventDetail(eventId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}/api/${this.language}/event/${eventId}`)
      .pipe(
        map((resData) => {
          return resData.data;
        })
      );
  }

  getEventCountdown(eventSlug: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/events/${eventSlug}/countdown`
    )
  }

  getEventTicket(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.get<any>(
          `${environment.apiUrl}/api/event/tickets/${eventId}`,
          httpOptions
        );
      })
    );
  }

  getEventServiceCharge(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.get<any>(
          `${environment.apiUrl}/api/event/service_charge/${eventId}`,
          httpOptions
        );
      })
    );
  }

  buyTicket(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("event_id", params.event_id);
        body.append("billing_name", params.billing_name);
        body.append("billing_mail", params.billing_mail);
        body.append("billing_phone", params.billing_phone);
        params.ticket.forEach((ticket:any) => {
          body.append("ticket_id[]", ticket.ticket_id);
          body.append("ticket_qty[]", ticket.ticket_qty);
        });

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/buyticket`,
          body,
          httpOptions
        );
      })
    );
  }

  buyTicketV2(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("member_id", params.member_id);
        body.append("event_id", params.event_id);
        body.append("is_myticket", "[]");
        body.append("payment_id", params.payment_id);
        params.ticket.forEach((ticket:any) => {
          body.append("ticket_id[]", ticket.ticket_id);
          body.append("ticket_qty[]", ticket.ticket_qty);
        });
        if (params.phone) {
          body.append("billing_phone", params.phone);
        }
        if (params.token_id) {
          body.append("token_id", params.token_id);
        }
        if (params.authentication_id) {
          body.append("authentication_id", params.authentication_id);
        }
        if (params.card_cvn) {
          body.append("card_cvn", params.card_cvn);
        }

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        // return this.http.post<any>(
        //   `${environment.apiUrl}/api/v2/event/buyticket`,
        //   body,
        //   httpOptions
        // );
        return this.http.post<any>(
          `${environment.API2Url}/kelolain_transaction/add_transaction_ticket`,
          body,
          httpOptions
        );
      })
    );
  }

  getMyEvent(status: string) {
    return this.auth.token.pipe(
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/${this.language}/member/event/${status}`,
          httpOptions
        );
      })
    );
  }

  getMaterialList(eventId: number, type: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/workshopmaterial/${type}`,
          httpOptions
        );
      })
    );
  }

  getBrochureList(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/brochure_list`,
          httpOptions
        );
      })
    );
  }

  getBrochureDetail(brochureId:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/brochure/${brochureId}`,
          httpOptions
        );
      })
    );
  }

  getFaqList(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/faq`,
          httpOptions
        );
      })
    );
  }

  getFaqDetail(faqId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/faq/${faqId}`,
          httpOptions
        );
      })
    );
  }

  getMyPointList(eventId: number, page = 1) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/${this.language}/event/${eventId}/point/new_history`,
          httpOptions
        );
      })
    );
  }

  getMyPointDaily(eventId: number, date: string) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/${this.language}/event/${eventId}/point/new_history?startDate=${date}`,
          httpOptions
        );
      })
    );
  }

  getLeaderboardList(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/point/leaderboard`,
          httpOptions
        );
      })
    );
  }

  getDailyLeaderboardList(eventId: number, date: String) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/point/leaderboard?startDate=${date}`,
          httpOptions
        );
      })
    );
  }

  checkQRcode(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        let body = new FormData();
        body.append("qrcode", params.qrcode);
        body.append("join_event", params.join_event);
        body.append("language", this.language);

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/scan_ticket`,
          body,
          httpOptions
        );
      })
    );
  }

  checkMemberHasEvent(eventId:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/memberhasevent/${eventId}`,
          httpOptions
        );
      })
    );
  }

  cartList(eventId: number) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
            // 'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjQ5Mjd9.NGM3NmMxMDJkZjQ0MTllNjcwNjYwYmZmZTUyYzIzMTY1YTkxNjBjODJlZGRiMWVmM2Y4ZjA1YjQ3MDFhZjVhZA`
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/${this.language}/event/${eventId}/shop/cart`,
          httpOptions
        );
      })
    );
  }
  pubDeliveryOption(data: any) {
    this.sbj.next(data);
  }
  obvDeliveryOption(): Subject<any> {
    return this.sbj;
  }

  cartAdd(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("event_id", params.event_id);
        body.append("product_id", params.product_id);
        body.append("product_qty", params.product_qty);
        body.append("notes", params.notes);
        body.append("delivery_option", params.delivery_option);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/shop/cart/add`,
          body,
          httpOptions
        );
      })
    );
  }

  cartUpdate(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("cart_id", params.cart_id);
        body.append("product_qty", params.product_qty);
        body.append("notes", params.notes);
        body.append("delivery_option", params.delivery_option);
        body.append("member_address_id", "");

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/shop/cart/update`,
          body,
          httpOptions
        );
      })
    );
  }

  cartDelete(params: any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("cart_id", params.cart_id);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/shop/cart/delete`,
          body,
          httpOptions
        );
      })
    );
  }

  scanQRCode(qrcode:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("qrcode", qrcode);
        body.append("language", this.language);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/scan_qrcode`,
          body,
          httpOptions
        );
      })
    );
  }

  searchEventByQR(qrcode:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("qrcode", qrcode);
        body.append("language", this.language);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/search`,
          body,
          httpOptions
        );
      })
    );
  }

  checkVersion(app_version:any, device_type:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("app_version", app_version);
        body.append("device_type", device_type);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/apps/check_version`,
          body,
          httpOptions
        );
      })
    );
  }

  getFixedPrice(kabupaten_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("kabupaten_id", kabupaten_id);

        return this.http.post<any>(
          `${environment.API3Url}/get_data/get_fixed_price`,
          body
        );
      })
    );
  }

  getEventHomeMenu(event_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("language", this.language);
        body.append("event_id", event_id);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/member/member_menu`,
          body,
          httpOptions
        );
      })
    );
  }

  activityTrack() {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/member/activity/track`,
          body,
          httpOptions
        );
      })
    );
  }

  getTextAreaContent(text_area_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("text_area_id", text_area_id);
        body.append("language", this.language);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/menu/textarea`,
          body,
          httpOptions
        );
      })
    );
  }

  RSVPEvent(event_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("event_id", event_id);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/rsvp/question`,
          body,
          httpOptions
        );
      })
    );
  }
  getHelpDesk(eventId: number) {
    return this.auth.token.pipe(
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(
          `${environment.apiUrl}/api/event/${eventId}/helpdesk`,
          httpOptions
        );
      })
    );
  }


  submitRSVP(params:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("event_id", params.event_id);
        body.append("ticket_id", params.ticket_id);
        params.questions.forEach((q:any) => {
          body.append("question_id[]", q.question_id);
          body.append("question_answer[]", q.result);
        });
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/rsvp/submit`,
          body,
          httpOptions
        );
      })
    );
  }

  getRSVPAnswer(guest_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("guest_id", guest_id);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/rsvp/get`,
          body,
          httpOptions
        );
      })
    );
  }

  redeemActivity(event_id:any, activities_id:any, badge_id:any) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();
        body.append("activities_id", activities_id);
        body.append("badges_id", badge_id);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/event/${event_id}/do_activity`,
          body,
          httpOptions
        );
      })
    );
  }

  private setLocalData(key:any, data:any) {
    this.helper.setStorage(`${environment.apiUrl}-${key}`, data);
  }

  // Get cached API result
  private getLocalData(key:any) {
    return this.helper.getStorage(`${environment.apiUrl}-${key}`);
  }

  downloadFile(url:any) {
    let headers = new HttpHeaders();
    headers = headers.set("Accept", "application/pdf");
    return this.http.get(url, {
      headers: headers,
      responseType: "blob",
    });
  }
  downloadHasil(hargaProperty:any, dpPayment:any, jangkaWaktu:any, bunga:any, angsuran:any, bungaDp:any, bungaPersentase:any) {
    // console.log("Param : " + JSON.stringify(params.value))

    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();

        body.append("hargaProperty", hargaProperty);
        body.append("dpPayment", dpPayment);
        body.append("jangkaWaktu", jangkaWaktu);
        body.append("bunga", bunga);
        body.append("angsuran", angsuran);
        body.append("bungaDp", bungaDp);
        body.append("bungaPersentase", bungaPersentase);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        // return this.http.post<any>(
        //   `${environment.apiUrl}/api/simulasi-kpr`,
        //   body,
        //   httpOptions
        // );

        return this.http.get<any>(
          `${environment.apiUrl}/api/simulasi-kpr?hargaProperty=${hargaProperty}&dpPayment=${dpPayment}&jangkaWaktu=${jangkaWaktu}&bunga=${bunga}&angsuran=${angsuran}&bungaDp=${bungaDp}&bungaPersentase=${bungaPersentase}`,
          httpOptions
        );

      })
    );
  }

  downloadHasil2(hargaProperty:any, dpPayment:any, jangkaWaktu:any,angsuran:any, name:any,dpPersen:any) {
    // console.log("Param : " + JSON.stringify(params.value))

    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {


        const body = {
          hargaProperty:hargaProperty,
          dpPayment:dpPayment,
          jangkaWaktu:jangkaWaktu,
          name:name,
          dpPersen:dpPersen,
          angsuran:angsuran
        }
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        // return this.http.post<any>(
        //   `${environment.apiUrl}/api/simulasi-kpr`,
        //   body,
        //   httpOptions
        // );

        return this.http.post<any>(
          `${environment.apiUrl}/api/simulasi-kpr`,
          body,
          httpOptions
        );

      })
    );
  }
  submitHadiah(params: any, type: string) {
    // console.log("Param : " + JSON.stringify(params.value))

    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();

        if (type == "sakuku") {
          body.append("hadiah", type);
          body.append("name", "");
          body.append("phone", params.value.ponsel);
          body.append("alamat", "");
        } else if (type == "flazz") {
          body.append("hadiah", type);
          body.append("name", params.value.penerima);
          body.append("phone", params.value.ponsel);
          body.append("alamat", params.value.alamat);
          body.append(
            "kabupaten_id",
            params.value.kabupaten_id[0].kabupaten_id
          );
          body.append("kodepos", params.value.kodepos);
        }

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/hubungi_hadiah`,
          body,
          httpOptions
        );
      })
    );
  }

  checkWinner() {
    // console.log("Param : " + JSON.stringify(params.value))

    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.get<any>(
          `${environment.apiUrl}/api/check_winner`,
          httpOptions
        );
      })
    );
  }

  memberAddActivity(type: string, id: string, name: string) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();

        body.append("type", type);
        body.append("id", id);
        body.append("name", name);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/member/add_activity`,
          body,
          httpOptions
        );
      })
    );
  }

  addReportBrochureNew(
    brochureId: any,
    kprParentId: any,
    kprHouseId: any,
    brochureName: any
  ) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();

        body.append("brochureId", brochureId);
        body.append("brochureName", brochureName);
        body.append("kprParentId", kprParentId);
        body.append("kprHouseId", kprHouseId);
        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.apiUrl}/api/member/create_brochure_new_report`,
          body,
          httpOptions
        );
      })
    );
  }

  memberSearchActivity(type: string, search_params: object) {
    return this.auth.token.pipe(
      take(1),
      switchMap((token) => {
        let body = new FormData();

        body.append("type", "searchParameter");
        body.append("data", JSON.stringify(search_params));
        body.append("action", "Search");
        body.append("dataUser", localStorage['dataGlobal']);

        const httpOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };

        return this.http.post<any>(
          `${environment.urlAnalytic}`,
          body,
          httpOptions
        );
      })
    );
  }
}
